import Vue from "vue"
import byButton from "./ByButton.vue"
import  SvgIcon  from "./SvgIcon.vue"
import ByCard from "./ByCard.vue"
import ByTables from "./ByTable.vue"
import ByTableTd from "./ByTableTd.vue"
import ByTableTh from "./ByTableTh.vue"
import orderSuccessDialog from '@/components/backstageManagement/public/orderSuccessDialog.vue'
import ByButton2 from "./ByButton2.vue"

Vue.component('by-button',byButton)
Vue.component('by-card',ByCard)
Vue.component('orderSuccessDialog',orderSuccessDialog)
Vue.component('SvgIcon',SvgIcon)
Vue.component('ByButton2',ByButton2)
Vue.component('ByTables',ByTables)
Vue.component('ByTableTd',ByTableTd)
Vue.component('ByTableTh',ByTableTh)


// WEBPACK FOOTER //
// ./src/common/components/index.js